import axios from 'axios';
import { USER_STORAGE_USER_KEY } from '../sagas/login/utils';
import { API_URL } from '../constants/api';
import { get } from 'lodash';
import { loginActions } from '../store/login/actions';

const TEN_MINUTES = 1000 * 60 * 10;

export const getApiAuthorization = () => {
  const token = window.localStorage.getItem(USER_STORAGE_USER_KEY);
  if (token && token.length && token !== 'undefined') {
    return JSON.parse(token).value;
  }
  //TODO: delete after
  if (token === 'undefined') {
    window.localStorage.removeItem(USER_STORAGE_USER_KEY);
  }
  return '';
};

export const setUpAxios = () => {
  const t = getApiAuthorization();
  axios.defaults.headers.common['X-Device-Platform'] = 'WEB';
  axios.defaults.headers.common['Authorization'] = `Bearer ${t}`;
  axios.defaults.baseURL = API_URL;

  axios.interceptors.response.use(
    (response) => response.data,
    (error) => {
      if (
        get(error, ['response', 'status']) === 403 ||
        get(error, ['response', 'status']) === 401
      ) {
        const type = get(error, ['response', 'data', 'error', 'type']);
        if (type === 'INVALID_ACCESS_TOKEN') {
          window.localStorage.removeItem(USER_STORAGE_USER_KEY);
          window.location.replace('/login');
          loginActions.logoutRequestAction();
          return;
        }
      }

      const err = get(error, ['response', 'data', 'error']);
      throw err ? err : error;
    },
  );
};

export const setUpAxiostoken = (token: string) => {
  return (axios.defaults.headers.common['Authorization'] = `Bearer ${token}`);
};

export const isAfterTenMinutes = (timestamp: number): boolean =>
  timestamp + TEN_MINUTES < Date.now();
